import type { QueryClient } from '@tanstack/react-query'

import { fetchConfirmedBuildMeta } from './build-meta'
import { isVersionCheckEnabled } from './version-check-gate'

export const ROUTE_CHANGE_THROTTLE_MS = 60_000

let lastCheckedAt = 0

export function checkOnRouteChange(queryClient: QueryClient): void {
  if (!isVersionCheckEnabled()) return

  const now = Date.now()
  if (now - lastCheckedAt < ROUTE_CHANGE_THROTTLE_MS) return

  lastCheckedAt = now
  void queryClient.fetchQuery({
    queryKey: ['build-meta'],
    queryFn: fetchConfirmedBuildMeta,
    staleTime: 0
  })
}
